class RRMediaPromos extends HTMLElement {
  connectedCallback() {
    if (this.dataset.layout !== 'slider' || this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    this.track = this.querySelector('[data-rr-promo-track]');
    this.slides = Array.from(this.querySelectorAll('[data-rr-promo-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-rr-promo-dot]'));
    this.previousButton = this.querySelector('[data-rr-promo-prev]');
    this.nextButton = this.querySelector('[data-rr-promo-next]');
    this.index = 0;
    this.scrollTimer = null;
    this.autoplayTimer = null;

    if (!this.track || this.slides.length < 2) return;

    this.previousButton?.addEventListener('click', () => this.goTo(this.index - 1, true));
    this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1, true));
    this.dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => this.goTo(dotIndex, true)));

    this.track.addEventListener('scroll', () => {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => this.syncFromScroll(), 80);
    }, { passive: true });

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.start());
    document.addEventListener('visibilitychange', this.handleVisibility = () => {
      if (document.hidden) this.pause(); else this.start();
    });

    this.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-rr-promo-slide]');
      if (!slide) return;
      this.pause();
      this.goTo(this.slides.indexOf(slide), false);
    });

    this.updateControls();
    this.start();
  }

  disconnectedCallback() {
    this.pause();
    window.clearTimeout(this.scrollTimer);
    if (this.handleVisibility) document.removeEventListener('visibilitychange', this.handleVisibility);
  }

  goTo(nextIndex, userInitiated = false) {
    const count = this.slides.length;
    this.index = (nextIndex + count) % count;
    const slide = this.slides[this.index];
    const left = slide.offsetLeft - this.track.offsetLeft;
    this.track.scrollTo({ left, behavior: userInitiated ? 'smooth' : 'auto' });
    this.updateControls();
    if (userInitiated) this.restart();
  }

  syncFromScroll() {
    const trackLeft = this.track.getBoundingClientRect().left;
    let closestIndex = 0;
    let closestDistance = Infinity;
    this.slides.forEach((slide, slideIndex) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = slideIndex;
      }
    });
    this.index = closestIndex;
    this.updateControls();
  }

  updateControls() {
    this.dots.forEach((dot, dotIndex) => {
      if (dotIndex === this.index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  start() {
    if (this.dataset.autoplay !== 'true' || window.Shopify?.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (this.autoplayTimer) return;
    const interval = Math.max(Number(this.dataset.interval) || 6000, 3000);
    this.autoplayTimer = window.setInterval(() => this.goTo(this.index + 1, false), interval);
  }

  pause() {
    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }

  restart() {
    this.pause();
    this.start();
  }
}

if (!customElements.get('rr-media-promos')) customElements.define('rr-media-promos', RRMediaPromos);
